import api from '@/services/Api';

class NationalMemberOrganizations {
  /**
   * Get all the address types
   * @returns {AxiosPromise<any>}
   */
  static all() {
    return api.get('/ref/national-member-organizations');
  }

  /**
   * @param {object} data
   * @param {number} data.country_id
   * @param {string} data.name
   * @param {string|null} [data.notes]
   * @param {Array<{year: number, amount: number}>|null} [data.fees]
   * @param {object|null} [data.contact_info]
   * @param {string|null} [data.contact_info.email]
   * @param {string|null} [data.contact_info.postal_address]
   * @param {string|null} [data.contact_info.web_link]
   * @returns {AxiosPromise<any>}
   */
  static create(data) {
    return api.post('/ref/national-member-organizations', data);
  }

  /**
   * @param {number|string} id
   * @returns {AxiosPromise<any>}
   */
  static get(id) {
    return api.get(`/ref/national-member-organizations/${id}`);
  }

  /**
   * @param {number|string} id
   * @param {object} data
   * @param {number} data.country_id
   * @param {string} data.name
   * @param {string|null} [data.notes]
   * @param {Array<{year: number, amount: number}>|null} [data.fees]
   * @param {object|null} [data.contact_info]
   * @param {string|null} [data.contact_info.email]
   * @param {string|null} [data.contact_info.postal_address]
   * @param {string|null} [data.contact_info.web_link]
   * @returns {AxiosPromise<any>}
   */
  static update(id, data) {
    return api.put(`/ref/national-member-organizations/${id}`, data);
  }
}

export default NationalMemberOrganizations;
